import axiosInstance from "../../../utils/axios";

const path = "common/early-access";

export const Submit = async (data) => {
    return await axiosInstance().post(`${path}/submit`, data);
};
